module.exports = __webpack_public_path__ + "static/img/320_TO8_2491_og.ffdfebd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/320_TO8_2491_og.jpg
// module id = HFel
// module chunks = 0